import { render, staticRenderFns } from "@/manager/client/views/partial/client-filter/client-filter.pug?vue&type=template&id=58072d7c&scoped=true&lang=pug&external"
import script from "./client-filter.view.vue?vue&type=script&lang=ts"
export * from "./client-filter.view.vue?vue&type=script&lang=ts"
import style0 from "@/manager/client/views/partial/client-filter/client-filter.scss?vue&type=style&index=0&id=58072d7c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58072d7c",
  null
  
)

export default component.exports